// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc65dba7","239":"906ef449","455":"4cd7696f","488":"d95580c0","762":"68e56ec7"}[chunkId] + ".chunk.js";
};